import { ChangeEvent } from "react";

import { Icon, SearchSVG, type SvgComponentType } from "@newsela/angelou";

import {
  rootCss,
  iconCss,
  rootCssWithBorder,
  createStandardInputcss,
  labelTextCss,
  labelCss,
} from "./StandardsModalSearchInput.styles";

interface IStandardsModalSearchInput {
  value?: string;
  isCreateStandardMode?: boolean;
  onChange?: (value: string) => void;
  disabled?: boolean;
}

const StandardsModalSearchInput = ({
  value = "",
  isCreateStandardMode = false,
  onChange,
  disabled,
}: IStandardsModalSearchInput) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    if (onChange) onChange(val);
  };

  return (
    <div css={isCreateStandardMode ? rootCss : rootCssWithBorder}>
      <Icon
        SvgComponent={SearchSVG as SvgComponentType}
        __cssFor={iconCss(isCreateStandardMode)}
      />
      <label
        data-testid="standards-modal-search-input"
        htmlFor="standards-modal-search-input"
        css={labelCss(isCreateStandardMode)}
      >
        <span css={labelTextCss}>Search for standards</span>
        <input
          id="standards-modal-search-input"
          data-qa-selector="standards-modal-search-input-create-set"
          data-testid="standards-modal-search-input-create-set"
          value={value}
          onChange={handleChange}
          css={createStandardInputcss}
          placeholder="Standard code"
          disabled={disabled}
        />
      </label>
    </div>
  );
};

export { StandardsModalSearchInput };
